import React, {useState} from "react";
import {Card, Container, Form, Modal} from "react-bootstrap";
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {router, useForm, usePage} from "@inertiajs/react";
import {ReactSelectBootstrap} from "react-select-bootstrap";
import {allExpanded, defaultStyles, JsonView} from "react-json-view-lite";
import KeyValueTable from "../../Components/KeyValueTable.jsx";
import UserFormFields from "../../Components/Users/UserFormFields.jsx";

function Edit() {
    const {t} = useEnhancedTranslation();
    const {user, roles, departments = [], settings, users, printers = [], printersAvailable = true, defaultPrinter = null} = usePage().props;
    const [imagePreview, setImagePreview] = useState(null);
    const [showCopySettingsModal, setShowCopySettingsModal] = useState(false);
    const [selectedUserForCopy, setSelectedUserForCopy] = useState(null);

    const jsonStyle = {
        ...defaultStyles,
        container: "json-view-container",
    };

    const userOptions = Object.keys(users || {}).map(id => ({
        value: parseInt(id),
        label: users[id],
    }));

    const initialUserRoles = user?.roles
        ? user.roles.map(role => ({
            value: role.id,
            label: roles.find(item => item.id === role.id)?.name || `Role ${role.id}`,
        }))
        : [];

    const {data, setData, post, errors} = useForm(
        user
            ? {
                name: user.name,
                email: user.email,
                weclapp_id: user.weclapp_id,
                role_id: initialUserRoles.map(role => role.value),
                department_ids: user.departments?.map(department => department.id) || [],
                password: "",
                color: user.color || "#000000",
                image: user.preview_image,
                homepage_route: user.homepage_route,
                is_active: user.is_active ? 1 : 0,
                delete_image: false,
                default_printer: defaultPrinter || "",
            }
            : {
                name: "",
                email: "",
                weclapp_id: "",
                role_id: [],
                department_ids: [],
                password: "",
                color: "#000000",
                image: null,
                homepage_route: null,
                is_active: 1,
                delete_image: false,
                default_printer: "",
            },
    );

    function handleSubmit(event) {
        event.preventDefault();
        if (user) {
            post(`/user/${user.id}`, {forceFormData: true});
        } else {
            post("/user", {forceFormData: true});
        }
    }

    const handleCopySettings = () => {
        router.get(`/user/copysettings/${selectedUserForCopy.value}/${user.id}`);
    };

    return <>
        <Container className="mt-3">
            <Form onSubmit={handleSubmit}>
                <Card className="mb-3">
                    <Card.Header className="d-flex justify-content-between">
                        <h5>{t(user ? "Edit User" : "Create User")}</h5>
                        <Button variant="primary" type="submit">
                            {t("save")}
                        </Button>
                    </Card.Header>
                    <Card.Body>
                        <UserFormFields
                            data={data}
                            setData={setData}
                            errors={errors}
                            roles={roles}
                            departments={departments}
                            printers={printers}
                            printersAvailable={printersAvailable}
                            imagePreview={imagePreview}
                            onImagePreview={setImagePreview}
                        />
                    </Card.Body>
                </Card>
            </Form>

            <KeyValueTable
                title={t("user settings")}
                button={<Button
                    variant="primary"
                    disabled={!user?.id}
                    onClick={() => setShowCopySettingsModal(true)}
                    type="button"
                >
                    {t("copy usersettings")}
                </Button>}
                keyHeader="Schlüssel"
                valueHeader="Wert"
                data={settings}
                valueRenderer={value => <JsonView
                    style={jsonStyle}
                    data={value}
                    shouldExpandNode={allExpanded}
                />}
            />
        </Container>

        <Modal show={showCopySettingsModal} onHide={() => setShowCopySettingsModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t("Select User to Copy Settings")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ReactSelectBootstrap
                    options={userOptions}
                    value={selectedUserForCopy}
                    onChange={setSelectedUserForCopy}
                    className={errors.user_copy ? "is-invalid" : ""}
                />
                {errors.user_copy && <div className="invalid-feedback">{errors.user_copy}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCopySettingsModal(false)}>
                    {t("Cancel")}
                </Button>
                <Button
                    variant="primary"
                    disabled={!selectedUserForCopy}
                    onClick={() => {
                        handleCopySettings();
                        setShowCopySettingsModal(false);
                    }}
                >
                    {t("Copy Settings")}
                </Button>
            </Modal.Footer>
        </Modal>
    </>;
}

export default Edit;
